import { Banner, Box, CloseButton } from '@zillow/constellation-10';

import { bannerBoxRecipe } from './styles';

import { useAuth } from '../AuthProvider';

import type { BannerToCloseArg } from '../../containers/PropertiesPage';

type Props = {
  displayPaymentsNotification: boolean;
  displayApplicationsNotification: boolean;
  displayLeasesNotification: boolean;
  displayListingClaimCompleteBanner: boolean;
  handleBannerCloseClick: (arg: BannerToCloseArg) => void;
};

const Notifications = ({
  displayPaymentsNotification,
  displayApplicationsNotification,
  displayLeasesNotification,
  displayListingClaimCompleteBanner,
  handleBannerCloseClick,
}: Props): JSX.Element => {
  const { user } = useAuth();

  return (
    <div>
      {displayListingClaimCompleteBanner && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick('displayListingClaimCompleteBanner')}
          >
            Select a property below to view and manage its information
          </Banner>
        </Box>
      )}

      {displayApplicationsNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick('displayApplicationsNotification')}
          >
            Applications are enabled for your properties. You can change application preferences anytime on the
            property&apos;s&nbsp;
            <em>Applications</em>
            &nbsp;tab.
          </Banner>
        </Box>
      )}

      {displayPaymentsNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick('displayPaymentsNotification')}
          >
            To manage your rent payments, select&nbsp;
            <em>Payments</em>
            &nbsp;for any property below
          </Banner>
        </Box>
      )}

      {displayLeasesNotification && (
        <Box css={bannerBoxRecipe.raw({ isEnterpriseCustomer: user?.isEnterpriseCustomer ?? false })}>
          <Banner
            tone="success"
            closeButton={<CloseButton onImpact={true} />}
            onClose={() => handleBannerCloseClick('displayLeasesNotification')}
          >
            For your properties with a&nbsp;
            <em>Leases</em>
            {}
             tab, select on it to create a custom lease
          </Banner>
        </Box>
      )}
    </div>
  );
};

export default Notifications;
